<!--
 * @Author: 
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-30 11:20:33
 * @Description: 
-->
<template>
    <div class="flex flex-nowrap justify-center items-center relative">
        <!-- 👇 币种切换下拉菜单，仅在调试中启用, 详见: https://app.asana.com/0/1207299192698511/1209122108972002/f -->
        <!-- 此处使用 v-show 不使用 v-if 以便发布后特定情景下 debug -->
        <div v-show="showWallet4test">
            <i class="wallet flex justify-center items-center mr-2 !px-2">
                💲
            </i>
            <q-menu :offset="[65, 8]" :style="{ background: 'transparent' }" v-model="showCollapse" max-width="220px"
                anchor="bottom right" self="top right">
                <div class="dropdown-menu py-2 px-2">
                    <!-- max-h-[300px] -->
                    <ul class="overflow-auto mt-1 gap-1 flex flex-row flex-1">
                        <li v-for="[sKey, oValue] in Object.entries(userStore.currencies)" :key="sKey"
                            class="one-currency flex justify-between py-3 rounded-lg px-2 w-full"
                            :class="{ 'active-current': settingStore.pickedCurrency === sKey }"
                            @click="() => onCurrencyClick(sKey)">
                            <div class="flex gap-2 justify-center items-center">
                                <img class="w-[24px]" :src="cryptosImages[sKey]" />
                                <span class="currency-name">
                                    {{ sKey.toUpperCase() }}
                                </span>
                            </div>
                            <!-- 右侧余额 -->
                            <div class="flex justify-center items-center">
                                <span v-if="oValue.balanceDelay">
                                    {{
                                        Number(getFixed(oValue.balanceDelay, 2)).toLocaleString(void 0, {
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2,
                                        })
                                    }}
                                </span>
                                <span v-else>0.00</span>
                            </div>
                        </li>
                    </ul>
                    <p v-if="isDev" :style="{
                        color: '#999',
                        padding: '5px',
                        borderTop: 'dashed 1px #666',
                    }">
                        触发按钮和此菜单仅在开发环境下显示，上线后不可见
                        <!-- 详见： https://app.asana.com/0/1207299192698511/1209122108972002/f -->
                    </p>
                </div>
            </q-menu>
        </div>
        <!-- 
            ↑ 调试专用组件，发布后不可见 
            ↓ 用户余额 
        -->
        <div class="wallet flex-nowrap flex justify-center gap-2 px-2 items-center" @click="emits('openAccountModel')">
            <CurrentCoin class="flex w-[20px]" />
            <span class="balance-value">
                <template v-if="!showFreen">
                    <span class="flex-1 relative min-w-[50px] text-center">
                        <span :class="{ 'invisible': unfreezeLoading }">
                            {{
                                Number(getFixed(userStore?.oNowCurrency?.balanceDelay, 2)).toLocaleString(void 0, {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2,
                                })
                            }}
                        </span>
                        <span v-if="unfreezeLoading" class="absolute inset-0 flex items-center">
                            {{ $t('game.loading') }}
                        </span>
                    </span>
                </template>
                <template v-else>
                    {{ getFixed(freezeCoin || 0, 2) }}
                </template>
                <!-- ↓ 用户余额变化的动画 -->
                <!-- ↓ 这里的 :style 控制金额颜色赢钱绿色，输钱灰白色 -->
                <span class="blance-changing" v-for="cur of aBalanceChanging" :key="cur?.ts"
                    :style="cur?.iMoneyEarned > 0 ? {} : { color: '#999' }">
                    <CurrentCoin class="w-[20px]" />
                    &nbsp;{{ (cur?.iMoneyEarned) }}
                </span>
            </span>
            <img v-if="isHome" src="@/assets/imgs/refresh.webp" class="w-[14px] h-[14px] cursor-pointer"
                :class="{ 'spin-loading': unfreezeLoading }" @click.stop="unFreeze" />
            <IconSvgUse class="wallet-icon" size="28px" use="icon-wallet" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import useSettingsStore from '@/stores/settings';
import { useCryptosImages } from '~/utils/fileImport';
import { useUserStore } from '~/stores/user';
import { useAuthSocket } from '@/socket/auth';
import useGlobalStore from '~/stores/global';
// import { useJoinStateStore } from '@/stores/cansino/joinState';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
import { getGameInfo, getGameName } from '~/common/js/gameAbout';
import { useGoldenFlower } from '@/socket/game/goldenFlower';
import { minus } from '~/utils/string';

const emits = defineEmits(['openAccountModel'])
const userStore = useUserStore();
const route = useRoute();
const globalStore = useGlobalStore();
const settingStore = useSettingsStore();
const currency = storeToRefs(settingStore).pickedCurrency;
// const joinStore = useJoinStateStore();
const autoOption = useAutoOptionStore();
// ↑ store 集中陈列区 ------------------------- 
// ↓ 其它
const isDev = import.meta.dev;
const showWallet4test = ref(import.meta.dev); // 出于调试的便利，添加此值 
const showCollapse = ref(false);
const { EMIT_CHANGE_CURRENCY } = useAuthSocket();
const { EMIT_FREEZE, EMIT_UNFREEZE } = useGoldenFlower();
// 👇 所有货币图标地址
const cryptosImages = useCryptosImages();
// 要显示冻结资金的游戏
const freenzeGame = ['zhajinhua']
const { t: $tFn } = useNuxtApp().$i18n;
const unfreezeLoading = ref(false);
const isHome = computed(() => route.path === '/' || route.path === '/cn');
const game = computed(() => getGameInfo(route.path).gameNameShort);
const showFreen = computed(() => !isHome.value && freenzeGame.includes(game.value))
const freezeCoin = computed(() => isHome.value ? undefined : userStore.freezes.find(it => it.game === game.value && it.coin_type.toLowerCase() === settingStore.pickedCurrency)?.coin_cnt);

// 👇切换币种的方法
const onCurrencyClick = (currency) => {
    showCollapse.value = false; // 先关闭菜单
    // 游戏正在进行中(自动游戏时)，不允许切换币种
    if (autoOption.isAutoBetting) {
        showNegativeNotify({
            i18n: `menuAndBtn.unableChange`,
        });
        return;
    }
    if (route.path.includes('/zhajinhuaGame/indoor')) {
        showNegativeNotify({
            i18n: `goldenFlower.exitRoom`,
        });
        return;
    }
    const oParms = { currency };
    const fnCallback = (oNewCurrenty) => {
        const isCorrect = oNewCurrenty?.currency == currency;
        console.log(`新币种更新：${isCorrect ? '✔✔✔' : '✘'}`, oNewCurrenty);
        if (!isCorrect) {
            console.error('注意，切换币种失败');
            showNegativeNotify({
                i18n: 'commonInfo.currencyChangedFailed',
            });
            // ↓ 在此终止，防止更新失败后在页面上造成更新成功的假象 
            return;
        }
        userStore.currentCurrency = currency;
        settingStore.$patch({
            ...settingStore.$state,
            pickedCurrency: currency,
        });
    };
    // ↓ 一定要“提前” 记录请求发起时间，用于后续判断 
    settingStore.pickedCurrencyTs = Date.now();
    // ▼ 报告服务器新币种
    EMIT_CHANGE_CURRENCY(oParms, fnCallback);
};


// ↓记录用户余额变化
const aBalanceChanging = reactive([]);
function deleteRecord(ts) {
    setTimeout(() => {
        const idx = aBalanceChanging.findIndex((cur) => cur.ts === ts);
        if (idx >= 0) aBalanceChanging.splice(idx, 1);
    }, 2_000);
}

function debounce<T extends (...args: any[]) => any>(fn: T, wait = 300) {
    let timer: ReturnType<typeof setTimeout> | null = null;
    return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
        if (timer) return;
        fn.apply(this, args);
        timer = setTimeout(() => {
            timer = null;
        }, wait);
    };
}

const UNFREEZE_TIMEOUT_MS = 12_000;

function withTimeout<T>(promise: Promise<T>, ms: number, label: string): Promise<T> {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => {
            reject(new Error(`${label} timeout after ${ms}ms`));
        }, ms);
        promise.then(
            (val) => { clearTimeout(timer); resolve(val); },
            (err) => { clearTimeout(timer); reject(err); },
        );
    });
}

const unFreeze = debounce(async () => {
    unfreezeLoading.value = true;
    try {
        const res = await withTimeout(
            EMIT_UNFREEZE({ currency: currency.value }),
            UNFREEZE_TIMEOUT_MS,
            'checkAndUnfreeze',
        );
        if (res.code) {
            let message = res.error;
            if (res.code === 4003) {
                console.log((res.error || '').split('-')[1]);
                const key = (res.error || '').split('-')[1];
                const cfg = { trial: 'novice', casual: 'leisure', premium: 'flagship', rick: 'royal', vip: 'supreme' };
                const roomName = cfg[key];
                console.log(111, $tFn(`goldenFlower.${roomName}`));
                roomName && (message = $tFn('goldenFlower.inRoom', { val: $tFn(`goldenFlower.${roomName}`) }));
            }
            showNegativeNotify({
                position: 'top',
                message,
                type: 'warning',
            });
        }
    } finally {
        unfreezeLoading.value = false;
    }
}, 1200);

function pushBalanceChanging(iMoneyEarned: number, source: 'balance' | 'freeze') {
    if (!iMoneyEarned) return;
    // 冻结模式下只允许 freeze 来源，非冻结模式下只允许 balance 来源
    const expectedSource = showFreen.value ? 'freeze' : 'balance';
    if (source !== expectedSource) return;
    // 清除另一种来源的残留动画，确保同一时刻只有一种效果
    aBalanceChanging.splice(0);
    const ts = Date.now();
    aBalanceChanging.push({
        ts,
        // ↓ 这里小数精度为4，因为有说过 mini 版 "下注金额" 输入框保留2位小数精度足矣，那么输赢金额保留4位小数就够了 
        // iMoneyEarned: isRedpacketGame.value ? iMoneyEarned.toFixed(2) : getFixed(iMoneyEarned, 2), 
        iMoneyEarned: getFixed(iMoneyEarned, 2),
    });
    deleteRecord(ts);
}

const balanceInitialized = ref(false);
watch(
    [() => userStore.oNowCurrency],
    (oNew, oOld) => {
        const [oCurrency] = oNew;
        const [oOldCurrency] = oOld;
        const isFirstLoad = [
            oCurrency.balanceDelay === oCurrency.balance,
            oOldCurrency.balance === 0,
            aBalanceChanging.length === 0,
        ].every(Boolean) && !balanceInitialized.value;
        if (isFirstLoad || (oCurrency.currencyName !== oOldCurrency.currencyName)) {
            balanceInitialized.value = true;
            return; // 币种切换也不能播放动画
        }
        balanceInitialized.value = true;
        const iMoneyEarned = minus(oCurrency.balanceDelay, oOldCurrency.balanceDelay);
        pushBalanceChanging(Number(iMoneyEarned), 'balance');
    },
    { deep: true },
);

// ↓ 冻结金额变化时的余额变动动画
const lastFreezeAnimVal = ref<string | undefined>(undefined);
watch(freezeCoin, (newVal, oldVal) => {
    if (oldVal === undefined) return;
    // 防止重连时缓存旧数据覆盖后再恢复，导致重复播放相同的变动动画
    if (newVal !== undefined && newVal === lastFreezeAnimVal.value) return;
    const iMoneyEarned = minus(newVal || 0, oldVal || 0);
    if (iMoneyEarned) lastFreezeAnimVal.value = newVal;
    pushBalanceChanging(iMoneyEarned, 'freeze');
});

// ── 炸金花资金冻结 / 解冻（路由级别管理） ──
const ZHAJINHUA_ENTRANCE = '/casino/zhajinhuaGame/entrance';
const ZHAJINHUA_INDOOR = '/casino/zhajinhuaGame/indoor';
const isZhajinhuaArea = (path: string) =>
    path.includes(ZHAJINHUA_ENTRANCE) || path.includes(ZHAJINHUA_INDOOR);

let _freezeEnterCurrency = ''; // FREEZE 时的币种，UNFREEZE 需要用同一个
let _freezePromise: Promise<any> | null = null;
let _hasDisconnected = false;
let _unwatchConnection: (() => void) | null = null;

function startFreezeWatch() {
    _hasDisconnected = false;
    _unwatchConnection?.();
    _unwatchConnection = watch(
        () => globalStore.wsConnection,
        (connected) => { if (!connected) _hasDisconnected = true; },
    );
}

function stopFreezeWatch() {
    _unwatchConnection?.();
    _unwatchConnection = null;
}

async function doFreeze() {
    const execFreeze = async (cur: string) => {
        _freezeEnterCurrency = cur;
        try {
            _freezePromise = EMIT_FREEZE({ currency: cur });
            const res = await _freezePromise;
            if (res?.code) {
                showNegativeNotify(res?.['error']);
            }
            return res;
        } catch (err) {
            console.error('[EMIT_FREEZE] rejected:', err);
            throw err;
        }
    };

    const cur = currency.value;
    if (cur) {
        await execFreeze(cur);
    } else {
        const stopWatch = watch(
            () => settingStore.pickedCurrency,
            async (newCur) => {
                if (newCur) {
                    stopWatch();
                    await execFreeze(newCur);
                }
            },
            { immediate: true },
        );
    }
}

async function doUnfreeze() {
    if (_hasDisconnected) return;
    if (_freezePromise) await _freezePromise.catch(() => { });
    const cur = _freezeEnterCurrency || currency.value;
    if (cur) {
        try {
            await withTimeout(
                EMIT_UNFREEZE({ currency: cur }),
                UNFREEZE_TIMEOUT_MS,
                'checkAndUnfreeze',
            );
        } finally {
            unfreezeLoading.value = false;
        }
    }
    _freezeEnterCurrency = '';
    _freezePromise = null;
}

watch(
    () => route.path,
    async (newPath, oldPath) => {
        const wasInZhajinhua = oldPath ? isZhajinhuaArea(oldPath) : false;
        const nowInEntrance = newPath.includes(ZHAJINHUA_ENTRANCE);
        const nowInZhajinhua = isZhajinhuaArea(newPath);

        if (nowInEntrance && !wasInZhajinhua) {
            // 首次进入炸金花大厅 → 冻结
            startFreezeWatch();
            await doFreeze();
        } else if (wasInZhajinhua && !nowInZhajinhua) {
            // 离开炸金花区域（非大厅也非游戏页）→ 解冻
            await doUnfreeze();
            stopFreezeWatch();
        }
    },
    { immediate: true },
);

onMounted(() => {
    // ↓ 以下操作为了便于调试 
    const sTestKey = 'showwalleticon';
    const sVal = new URLSearchParams(window.location.search).get(sTestKey);
    if (sVal) {
        localStorage.setItem(sTestKey, sVal);
    }
    showWallet4test.value = (
        import.meta.dev
        || localStorage.getItem(sTestKey) === 'show'
    );
});

onBeforeUnmount(() => {
    stopFreezeWatch();
});
</script>

<style lang="scss" scoped>
.wallet {
    background: var(--bg007);
    border-radius: 100px;
    box-shadow: 0 2px 3px #0000001f;
    height: 34px;
    padding: 0 8px 0 10px;
    cursor: pointer;
    position: relative;
}

.balance-value {
    display: flex;
    flex-flow: row nowrap;
    place-content: center;
    place-items: center;
    font-size: 12px;
    font-weight: 700;

    .blance-changing {
        display: flex;
        position: absolute;
        z-index: 2;
        left: 10px;
        top: 25px;
        animation-name: earned-money;
        animation-duration: 1.5s;
        animation-fill-mode: forwards;
        color: #1bb83d;
        font-weight: bold;
        will-change: transform;
        backface-visibility: hidden;
        // perspective: 1000px;
    }
}

.wallet-icon {
    color: rgba(67, 86, 215, 1);
    margin-left: -5px;
}

@keyframes earned-money {
    0% {
        opacity: 0.2;
        transform: translateY(0) scale(1);
    }

    10%,
    35% {
        opacity: 1;
        transform: translateY(15px) scale(1.3);
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
        transform: translateY(-15px) scale(1);
    }
}

.one-currency {
    cursor: pointer;
    font-weight: 600;
    color: white;

    &.active-current {
        background-color: #293546;
    }

    .currency-name {
        color: var(--color_grey-20);
        transition: all 0.2s;
        font-size: 16px;
    }

    &:hover {
        .currency-name {
            color: white;
        }
    }
}

.options-box {
    color: white;
}

.dropdown-menu {
    background: #1c2532;
    width: 220px;
}

.wallet-btn {
    background: linear-gradient(1turn, #c4003b 0.8%, #fb1949);
    ;
    white-space: nowrap;
    height: 36px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    position: relative;
    z-index: 2;
    cursor: default;

    svg {
        display: inline-block;
    }
}

.spin-loading {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

@media screen and (max-width: 480px) {
    .wallet-btn {
        min-width: 36px;
        width: 36px;

        :deep(.button-3d__outer) {
            padding: 0;
        }

        :deep(.icon-coat) {
            margin: 0px !important;
        }

        .word {
            display: none;
        }
    }
}
</style>
